import React, { Component } from 'react';
import Translate from 'react-translate-component';
import { pathOr } from 'ramda';

import XMLFields from './XMLFields';

const experienceFieldsXML = [
    { name: "PhoneIntervMain.JobExperience", label: 'JobExperience' },
    { name: "PhoneIntervMain.ForeignLanguage", label: 'ForeignLanguage' },
    { name: "PhoneIntervMain.DrivingLicense", label: 'DrivingLicense' },
    { name: "PhoneIntervMain.Education", label: 'Education' },
    { name: "PhoneIntervMain.PCSkills", label: 'PCSkills' },
];

const motivationFieldsXML = [
    { name: "PhoneIntervMain.WhatJobIsInterested", label: 'WhatJobIsInterested' },
    { name: "PhoneIntervMain.SalaryExpectations", label: 'SalaryExpectations' },
    { name: "PhoneIntervMain.JobSearchHistory", label: 'JobSearchHistory' },
    { name: "PhoneIntervMain.LocationRequirements", label: 'LocationRequirements' },
    { name: "PhoneIntervMain.AdditionalInformation", label: 'AdditionalInformation' },
    { name: "PhoneIntervMain.PersonalImpressions", label: 'PersonalImpressions' },
    { name: "PhoneIntervMain.ConverationOutcome", label: 'ConverationOutcome' },
];

export default class PhoneContact extends Component {
    componentDidMount() {
        const { event } = this.props;

        if (event && event.details) {
            const { details } = event;

            setTimeout(() => {
                this.props.form.change('result.xmlbody.PhoneIntervMain.INTDATE', details.eventDate);
                this.props.form.change('result.xmlbody.PhoneIntervMain.REKRKEY', pathOr('', ['responsible', 0, 'id'], details));
                this.props.form.change('result.xmlbody.PhoneIntervMain.CANDKEY', pathOr('', ['people', 0, 'id'], details));
                this.props.form.change('result.xmlbody.PhoneIntervMain.REKR', pathOr('', ['responsible', 0, 'text'], details));
                this.props.form.change('result.xmlbody.PhoneIntervMain.CAND', pathOr('', ['responsible', 0, 'text'], details));
            }, 0);
        }
    }

    render() {
        return (
            <div>
                <Translate content="xml.PplPhoneInterv.Experience" component='h3' />
                <XMLFields fieldsXML={experienceFieldsXML} translatePrefix="PplPhoneInterv" />

                <Translate content="xml.PplPhoneInterv.Motivation" component='h3' />
                <XMLFields fieldsXML={motivationFieldsXML} translatePrefix="PplPhoneInterv" />
            </div>
        );
    }
}
